






































import { Component, Vue, Prop } from "vue-property-decorator";
import { Button, Dialog, Toast } from "vant";
import customField from "@/components/customField/index.vue";
import { getBrowser } from "@/utils/browser";

const browser = getBrowser();

@Component({
  components: {
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [customField.name]: customField
  }
})
export default class PsdDialog extends Vue {
  form = {
    password: "",
    confirm_password: "",
    from: 3, // 1ios，2Android，3web
    register_type: 1
  };

  @Prop({
    type: Boolean,
    default: false
  })
  private showPsdDialog
  @Prop({
    type: String,
    default: ''
  })
  private zone_code
  @Prop({
    type: String,
    default: ''
  })
  private phone

  created(){
    //区分注册终端来源
    if (browser.isIosApp) {
      this.form.from = 1;
    } else if (browser.isAndroidApp) {
      this.form.from = 2;
    } else {
      this.form.from = 3;
    }
  }

  get isDisabled(){
    return !this.form.password || !this.form.confirm_password;
  }

  checkPassword() {
    const { password, confirm_password } = this.form;
    return password == confirm_password;
  }

  // 设置密码
  handleSubmitPsd(){
    if (!this.checkPassword()) {
      return Toast.fail(this.$t("register.password_verify_fail_text"));
    }
    const params = Object.assign(this.form, {
      zone_code: this.zone_code,
      phone: this.phone
    });
    (this as any).$apis
      .register(params)
      .then(res => {
        Dialog.alert({
          ["title" as any]: this.$t("common.tips"),
          ["message" as any]: this.$t("register.register_success_text")
        }).then(() => {
          // on close
          const { token, user_info } = res;
          
          (this as any).$localstorage.set("userInfo", user_info);
          sessionStorage.setItem("token", token);
          this.$router.go(-1);
        });
      })
      .catch(e => {
        
      });
  }
}
